import type { UseTrackImpressionEventByIntersectionParameters } from "@product/scmp-sdk";
import { useTrackImpressionEventByIntersection } from "@product/scmp-sdk";
import { useMemo } from "react";

import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import type { Event } from "~/components/tracking/google-analytics/types";

export const useTrackSegmentImpression = (segmentName?: string) => {
  const computeImpressionEvent = useMemo<
    UseTrackImpressionEventByIntersectionParameters<Event, null>["getEvent"]
  >(() => {
    if (!segmentName) return null;
    return () => ({
      action: `Impression/${segmentName.toLowerCase()}` as const,
      category: "Style Homepage Depth",
    });
  }, [segmentName]);
  const { captureTrackImpressionEventTargetElement } = useTrackImpressionEventByIntersection<
    Event,
    null
  >({
    gaTrackingHandler: sendGATracking,
    getEvent: computeImpressionEvent,
    options: { isSendGATracking: true, shouldSendOnce: true },
  });

  return {
    captureTrackImpressionEventTargetElement,
  };
};
